import {
  focusEditor,
  getPluginOptions,
  upsertLink,
  removeMark,
  floatingLinkActions,
  floatingLinkSelectors,
  ELEMENT_LINK,
} from '@udecode/plate';

import { validateUrl } from '../../../utils/validateUrl';

/**
 * Insert link if url is valid.
 * Text is url if empty.
 * Close floating link.
 * Focus editor.
 */
export const submitFloatingLink = (editor) => {
  if (!editor.selection) return;

  const { forceSubmit } = getPluginOptions(editor, ELEMENT_LINK);

  const url = floatingLinkSelectors.url();

  if (!forceSubmit && !validateUrl(editor, url)) return;

  const text = floatingLinkSelectors.text();
  const target = floatingLinkSelectors.newTab() ? '_blank' : undefined;

  floatingLinkActions.hide();

  removeMark(editor, { key: ['color'] });

  upsertLink(editor, {
    url,
    text,
    target,
    skipValidation: true,
    insertNodesOptions: {
      mode: 'lowest',
    },
  });

  setTimeout(() => {
    focusEditor(editor, editor.selection);
  }, 0);

  return true;
};
